const ACCESS_ROLES = {
  DISABLED: 0,
  USER: 10,
  MANAGER: 20,
  ADMIN: 30
};

class BaseMitUserModel{
    constructor(csailId, fname, lname, access, csailEmail,adminTicketExpire){
        this.user = {
          csailId: csailId,
          fname: fname,
          lname: lname,
          role: access,
          email:csailEmail,
          adminTicketExpire: adminTicketExpire
        };
    }
    get(){
      return this.user;
    }
}

BaseMitUserModel.ROLES = ACCESS_ROLES;

export default BaseMitUserModel;
